<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="TOC">
<a id="pagevi">
</a><a id="pagevii">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
</a><div class="contentsEntry" style="text-indent: 0%;"><a id="pagevii">
</a><p class="contentsEntry1" style="text-indent: 0%;"><a id="pagevii"></a><a href="#/001coverpage"><span class="color">Cover</span></a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntry1" style="text-indent: 0%;"><a href="#/002titlepage"><span class="color">Title Page</span></a></p></div>
<div class="contentsEntry" id="dedicationpage_01" style="text-indent: 0%;">
<p class="contentsEntry1" style="text-indent: 0%;"><a href="#/003dedicationpage01#dedicationpage01"><span class="color" id="ded">Dedication</span></a></p></div>
<div class="contentsEntry" id="frontmatterpage_01" style="text-indent: 0%;">
<p class="contentsEntryName1" style="text-indent: 0%;"><a href="#/005frontmatterpage01#frontmatterpage01">Foreword by Michael Anthony</a></p></div>
<div class="contentsEntry" id="chapter_01" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/006chapter01#chapter01">1</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/006chapter01#chapter01"><i>Hard Luck Son of a Bitch</i></a></p></div>
<div class="contentsEntry" id="chapter_02" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/007chapter02#chapter02">2</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/007chapter02#chapter02"><i>Mobile Home Blues</i></a></p></div>
<div class="contentsEntry" id="chapter_03" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/008chapter03#chapter03">3</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/008chapter03#chapter03"><i>Going to San Francisco</i></a></p></div>
<div class="contentsEntry" id="chapter_04" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/009chapter04#chapter04">4</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/009chapter04#chapter04"><i>Montrose</i></a></p></div>
<div class="contentsEntry" id="chapter_05" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/010chapter05#chapter05">5</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/010chapter05#chapter05"><i>The Red Rocker</i></a></p></div>
<div class="contentsEntry" id="chapter_06" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/011chapter06#chapter06">6</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/011chapter06#chapter06"><i>I Can’t Drive Fifty-five</i></a></p></div>
<div class="contentsEntry" id="photo_insert1" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/011chapter06#photoinsert1">Photographic Insert I</a></p>
</div>
<div class="contentsEntry" id="chapter_07" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/012chapter07#chapter07">7</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/012chapter07#chapter07"><i>5150</i></a></p></div>
<div class="contentsEntry" id="chapter_08" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/013chapter08#chapter08">8</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/013chapter08#chapter08"><i>Monsters of Rock</i></a></p></div>
<div class="contentsEntry" id="chapter_09" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/014chapter09#chapter09">9</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/014chapter09#chapter09"><i>Right Here, Right Now</i></a></p></div>
<div class="contentsEntry" id="chapter_10" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/015chapter10#chapter10">10</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/015chapter10#chapter10"><i>Cabo Wabo</i></a></p></div>
<div class="contentsEntry" id="chapter_11" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/016chapter11#chapter11">11</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/016chapter11#chapter11"><i>Father’s Day</i></a></p></div>
<div class="contentsEntry" id="chapter_12" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/017chapter12#chapter12">12</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/017chapter12#chapter12"><i>Mas Tequila</i></a></p></div>
<div class="contentsEntry" id="chapter_13" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/018chapter13#chapter13">13</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/018chapter13#chapter13"><i>Enter Irving</i></a></p></div>
<div class="contentsEntry" id="chapter_14" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/019chapter14#chapter14">14</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/019chapter14#chapter14"><i>Samurai Hair</i></a></p></div>
<div class="contentsEntry" id="photo_insert2" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/019chapter14#photoinsert2">Photographic Insert II</a></p>
</div>
<div class="contentsEntry" id="chapter_15" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/020chapter15#chapter15">15</a></p>
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/020chapter15#chapter15"><i>Going Home</i></a></p></div>
<div class="contentsEntry" id="chapter_16" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/021chapter16#chapter16">16</a></p>
<p class="contentsEntryName1" style="text-indent: 0%;"><a href="#/021chapter16#chapter16"><i>Who Wants to Be a Billionaire?</i></a></p></div>
<div class="contentsEntry1" id="backmatterpage_01" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/022backmatterpage01#backmatterpage01">Note from the Coauthor</a></p></div>
<div class="contentsEntry1" id="acknowledgmentpage_01" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/023acknowledgmentpage01#acknowledgmentpage01">Acknowledgments</a></p></div>
<div class="contentsEntry1" id="exc" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/Excerpt#exc" title="Link target outside of Sample">Excerpt from ARE WE HAVING ANY FUN YET?</span></p></div>
<div class="contentsEntry1" id="aboutauthor_page" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/024aboutauthorpage#aboutauthorpage">About the Authors</a></p></div>
<div class="contentsEntry1" id="credits_page" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/025creditspage#creditspage">Credits</a></p></div>
<div class="contentsEntry1" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780062042361_Hagar_adcard#zhead1" id="zhead2" title="Link target outside of Sample">Books by Sammy Hagar</span></p></div>
<div class="contentsEntry1" id="copyright_page" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/026copyrightpage#copyrightpage">Copyright</a></p></div>
<div class="contentsEntry1" id="aboutpublisher_page" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/027aboutpublisherpage#aboutpublisherpage">About the Publisher</a></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-TOC.vue?7362dad4